<template>
  <div class="page boss-page corrections-page">
    <van-nav-bar title="员工纠偏进展" left-arrow @click-left="$router.back()"/>
    <van-skeleton v-if="loading" title :row="10"/>
    <main v-else>
      <article v-for="item in items" :key="item.id">
        <header><em>{{ label(item.status) }}</em>
          <time>{{ date(item.createdAt) }}</time>
        </header>
        <h2>{{ item.title }}</h2>
        <p v-if="item.rationale">{{ item.rationale }}</p>
        <ul>
          <li v-for="(action,i) in item.actions" :key="i">{{ action }}</li>
        </ul>
        <blockquote v-if="item.employeeFeedback">员工反馈：{{ item.employeeFeedback }}</blockquote>
        <blockquote v-if="item.completionNote">完成结果：{{ item.completionNote }}</blockquote>
        <div v-if="['CHANGE_REQUESTED','DISPUTED'].includes(item.status)" class="buttons">
          <van-button size="small" type="danger" @click="review(item,'APPROVE_CHANGE')">确认后重新下达</van-button>
        </div>
        <div v-if="item.status==='SUBMITTED'" class="buttons">
          <van-button size="small" plain type="danger" @click="review(item,'RETURN')">退回完善</van-button>
          <van-button size="small" type="danger" @click="review(item,'VERIFY')">验收完成</van-button>
        </div>
      </article>
      <van-empty v-if="!items.length" description="暂无已下达纠偏事项"/>
    </main>
  </div>
</template>
<script>
import coreapi from '@/utils/coreapi';

export default {
  data() {
    return {items: [], loading: false}
  }, mounted() {
    this.load()
  }, activated() {
    this.load()
  }, methods: {
    async load() {
      this.loading = true;
      try {
        this.items = await coreapi.supervisorCorrections()
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }, label(v) {
      return {
        CONVEYED: '待员工回应',
        ACCEPTED: '已采纳',
        CHANGE_REQUESTED: '申请修改',
        DISPUTED: '提出异议',
        IN_PROGRESS: '执行中',
        SUBMITTED: '待验收',
        VERIFIED: '已完成'
      }[v] || v
    }, date(v) {
      return v ? new Date(v).toLocaleDateString('zh-CN') : '--'
    }, review(item, action) {
      this.$dialog.prompt({
        title: action === 'VERIFY' ? '验收纠偏结果' : action === 'RETURN' ? '退回完善' : '回复员工反馈',
        message: '填写主管意见'
      }).then(async note => {
        try {
          await coreapi.supervisorCorrectionAction(item.id, {action, note});
          this.$toast.success('处理完成');
          this.load()
        } catch (e) {
          this.$toast.fail(e.message)
        }
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang="less" scoped>@import '~@/assets/base.less';
@import '../../boss/boss.less';

.page {
  min-height: 100vh;
  margin: 0;
  padding-bottom: 1.7rem;
  background: #f6f7fb
}

.corrections-page /deep/ .van-nav-bar {
  margin: 0;
  width: 100%;
  height: 1.22667rem;
  border-radius: 0;
  background: linear-gradient(135deg,#351b1d,#c6282d);
}
.corrections-page /deep/ .van-nav-bar__title { color: #fff; font-size: .36rem; }
.corrections-page main { padding: .22rem .28rem; }

main {
  padding: .28rem
}

article {
  margin-bottom: .16rem;
  padding: .28rem;
  background: #fff;
  border-radius: .16rem;
  box-shadow: 0 .05rem .2rem rgba(0, 0, 0, .06)
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center
}

em {
  padding: .05rem .14rem;
  color: @color;
  background: #fff1f1;
  border-radius: .08rem;
  font-size: .22rem;
  font-style: normal
}

time {
  color: #999;
  font-size: .22rem
}

h2 {
  margin-top: .14rem;
  font-size: .32rem
}

p, li, blockquote {
  color: #626577;
  font-size: .26rem;
  line-height: 1.55
}

p, ul, blockquote {
  margin-top: .1rem
}

ul {
  padding-left: .36rem
}

blockquote {
  padding: .14rem;
  background: #f7f7f9;
  border-left: .06rem solid #d9891b
}

.buttons {
  margin-top: .18rem;
  display: flex;
  justify-content: flex-end;
  gap: .12rem
}</style>



// WEBPACK FOOTER //
// src/views/efficiency/supervisor/Corrections.vue